import React, { forwardRef } from "react";
import { TextField } from "@mui/material";
import { AlertType } from "./DSAlert";
import useAppContext from "../../hooks/useAppContext";
import { validateAndCleanEmojis } from "../../utils";
import { EMOJIS_NOT_ALLOWED_ALERT } from "../../consts/alerts";

interface DSTextFieldProps extends React.ComponentProps<typeof TextField> {
  preventEmojis?: boolean;
}

const DSTextField = forwardRef<HTMLInputElement, DSTextFieldProps>(
  (props, ref) => {
    const { preventEmojis = true, onChange, ...restProps } = props;
    const { showAlert } = useAppContext();

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      let finalEvent = event;

      if (preventEmojis) {
        const { hasEmoji, cleanedValue } = validateAndCleanEmojis(
          event.target.value,
        );

        if (hasEmoji) {
          event.target.value = cleanedValue;

          showAlert({
            message: EMOJIS_NOT_ALLOWED_ALERT,
            alertType: AlertType.ERROR,
          });

          finalEvent = {
            ...event,
            target: { ...event.target, value: cleanedValue },
          } as React.ChangeEvent<HTMLInputElement>;
        }
      }

      if (onChange) {
        onChange(finalEvent);
      }
    };
    return (
      <TextField
        ref={ref}
        {...restProps}
        onChange={handleChange}
        variant="outlined"
      />
    );
  },
);

export default DSTextField;
